import React from 'react';
import { bool, node, string } from 'prop-types';
import classNames from 'classnames';

import LayoutComposer from '../LayoutComposer';
import LayoutWrapperAccountSettingsSideNav from './LayoutWrapperAccountSettingsSideNav';

import css from './LayoutSideNavigation.module.css';

// Commonly used layout
const LayoutSideNavigation = props => {
  const {
    className,
    rootClassName,
    containerClassName,
    mainColumnClassName,
    sideNavClassName,
    children,
    topbar: topbarContent,
    footer: footerContent,
    sideNav: sideNavContent,
    useAccountSettingsNav,
    currentPage,
    topBarBackgroundColor,
    ...rest
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  // Causee restyle of the account settings pages (P25028-78). `useAccountSettingsNav`
  // is set by the four account settings pages and by nothing else, so it is the
  // scope for the cream floor + centred shell those pages need. Every other user
  // of this layout — the inbox — keeps the original classes. A page that passes
  // its own class names still wins, as before.
  const containerClasses =
    containerClassName || (useAccountSettingsNav ? css.accountContainer : css.container);
  const sideNavClasses = classNames(
    useAccountSettingsNav ? css.accountSideNav : css.sideNav,
    sideNavClassName
  );
  const mainClasses = classNames(
    useAccountSettingsNav ? css.accountMain : css.main,
    mainColumnClassName
  );

  // TODO: since responsiveAreas are still experimental,
  //       we don't separate "aside" through layoutComposer
  const layoutAreas = `
    topbar
    main
    footer
  `;

  return (
    <LayoutComposer areas={layoutAreas} className={classes} {...rest}>
      {layoutProps => {
        const { Topbar, Main, Footer } = layoutProps;
        return (
          <>
            <Topbar as="header" className={topBarBackgroundColor ? css.backgroundColorTopBar : css.topbar} style={{ backgroundColor: topBarBackgroundColor ? topBarBackgroundColor : "white" }}>
              {topbarContent}
            </Topbar>
            <Main as="div" className={containerClasses}>
              <aside className={sideNavClasses}>
                {useAccountSettingsNav ? (
                  <LayoutWrapperAccountSettingsSideNav currentPage={currentPage} />
                ) : null}
                {sideNavContent}
              </aside>
              <main className={mainClasses}>{children}</main>
            </Main>
            <Footer>{footerContent}</Footer>
          </>
        );
      }}
    </LayoutComposer>
  );
};

LayoutSideNavigation.displayName = 'LayoutSideNavigation';

LayoutSideNavigation.defaultProps = {
  className: null,
  rootClassName: null,
  sideNav: null,
  footer: null,
  useAccountSettingsNav: false,
  currentPage: null,
};

LayoutSideNavigation.propTypes = {
  className: string,
  rootClassName: string,
  children: node.isRequired,
  topbar: node.isRequired,
  sideNav: node,
  footer: node,
  useAccountSettingsNav: bool,
  currentPage: string,
};

export default LayoutSideNavigation;
